var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6663 24.9987L25.3163 19.9987L16.6663 14.9987V24.9987ZM35.933 11.9487C36.1497 12.732 36.2997 13.782 36.3997 15.1154C36.5163 16.4487 36.5663 17.5987 36.5663 18.5987L36.6663 19.9987C36.6663 23.6487 36.3997 26.332 35.933 28.0487C35.5163 29.5487 34.5497 30.5154 33.0497 30.932C32.2663 31.1487 30.833 31.2987 28.633 31.3987C26.4663 31.5154 24.483 31.5654 22.6497 31.5654L19.9997 31.6654C13.0163 31.6654 8.66634 31.3987 6.94967 30.932C5.44967 30.5154 4.48301 29.5487 4.06634 28.0487C3.84967 27.2654 3.69967 26.2154 3.59967 24.882C3.48301 23.5487 3.43301 22.3987 3.43301 21.3987L3.33301 19.9987C3.33301 16.3487 3.59967 13.6654 4.06634 11.9487C4.48301 10.4487 5.44967 9.48203 6.94967 9.06536C7.73301 8.8487 9.16634 8.6987 11.3663 8.5987C13.533 8.48203 15.5163 8.43203 17.3497 8.43203L19.9997 8.33203C26.983 8.33203 31.333 8.5987 33.0497 9.06536C34.5497 9.48203 35.5163 10.4487 35.933 11.9487Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiYoutube);
export default __webpack_public_path__ + "static/media/mdi_youtube.2c3b3ce4f28d8c269901a537b8e636d4.svg";
export { ForwardRef as ReactComponent };